export default __webpack_public_path__ + "static/media/497.33ae7158.jpg";